import { getRequest } from 'lib/api/api'

export const isUsernameAvailable = async (
  username: string,
): Promise<boolean> => {
  const request = await getRequest(`users/username/${username}`)
  return request.status === 404
}
